// assets
import { IconKey } from '@tabler/icons-react';

const hostedUI = process.env.REACT_APP_HOSTED_UI;

// constant
const icons = {
    IconKey
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages = {
    id: 'pages',
    title: 'Security',
    caption: 'Pages Caption',
    type: 'group',
    children: [
        {
            id: 'authentication',
            title: 'Authentication',
            type: 'collapse',
            icon: icons.IconKey,

            children: [
                {
                    id: 'login3',
                    title: 'Login',
                    type: 'item',
                    url: hostedUI,
                    target: true
                },
                {
                    id: 'register3',
                    title: 'Logout',
                    type: 'item',
                    url: '/',
                    target: true
                }
            ]
        }
    ]
};

export default pages;
